import * as React from 'react';
import { LeftPart } from './LoginLeftPart';
import LoginForm from './LoginForm';
import { IS_KOALA } from 'utils/config';

const LoginComponent = () => {
    const companyName = IS_KOALA ? 'Koala Games' : 'RubyPlay';
    const currentYear = new Date().getFullYear();

    return (
        <div className="relative flex min-h-screen bg-[radial-gradient(circle_at_top_right,rgba(207,9,32,0.10),transparent_28%),linear-gradient(180deg,#eef2f7_0%,#f8fafc_100%)]">
            <LeftPart />

            <div className="relative flex min-h-screen w-full items-center justify-center px-4 py-8 sm:px-6 lg:w-1/2 lg:px-10">
                <div className="absolute inset-0 lg:hidden">
                    <div
                        className="h-44 w-full bg-cover bg-center"
                        style={{
                            backgroundColor: 'var(--accent-color)',
                            backgroundImage:
                                'linear-gradient(180deg, rgba(10, 15, 33, 0.18), rgba(10, 15, 33, 0.52)), var(--background-image)',
                        }}
                    />
                </div>

                <div className="relative z-10 flex w-full max-w-2xl flex-col items-center">
                    <div
                        className="mb-[-2.5rem] h-24 w-16 bg-contain bg-center bg-no-repeat drop-shadow-[0_20px_32px_rgba(0,0,0,0.24)] lg:hidden"
                        style={{ backgroundImage: 'var(--login-logo)' }}
                    />
                    <LoginForm />
                    <div className="mt-6 text-center text-xs tracking-[0.02em] text-slate-400 [font-family:futura-pt,sans-serif] lg:hidden">
                        © 2017-{currentYear} {companyName}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginComponent;
